/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ai_Analysis_CompleteInputs */

const en_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI Analysis Complete`)
};

const es_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis IA completo`)
};

const fr_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyse IA terminée`)
};

const de_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-Analyse abgeschlossen`)
};

const ja_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI分析完了`)
};

const zh_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 分析完成`)
};

const ar_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اكتمل تحليل الذكاء الاصطناعي`)
};

const id_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisis AI Selesai`)
};

const it_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi IA Completata`)
};

const ru_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Анализ ИИ завершен`)
};

const pt_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análise de IA Concluída`)
};

const ko_ai_analysis_complete = /** @type {(inputs: Ai_Analysis_CompleteInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 분석 완료`)
};

/**
* | output |
* | --- |
* | "AI Analysis Complete" |
*
* @param {Ai_Analysis_CompleteInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const ai_analysis_complete = /** @type {((inputs?: Ai_Analysis_CompleteInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ai_Analysis_CompleteInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ai_analysis_complete(inputs)
	if (locale === "es") return es_ai_analysis_complete(inputs)
	if (locale === "fr") return fr_ai_analysis_complete(inputs)
	if (locale === "de") return de_ai_analysis_complete(inputs)
	if (locale === "ja") return ja_ai_analysis_complete(inputs)
	if (locale === "zh") return zh_ai_analysis_complete(inputs)
	if (locale === "ar") return ar_ai_analysis_complete(inputs)
	if (locale === "id") return id_ai_analysis_complete(inputs)
	if (locale === "it") return it_ai_analysis_complete(inputs)
	if (locale === "ru") return ru_ai_analysis_complete(inputs)
	if (locale === "pt") return pt_ai_analysis_complete(inputs)
	return ko_ai_analysis_complete(inputs)
});